const margins = { top: 30, right: 0, bottom: 0, left: 10 };

const settings = {
	// width depends on container and content
	width: 900,
	height: 600,

	axis: { lineWidth: 3 },
	axisY: {
		numTicks: 5,
		width: 75,
	},
	bands: {
		padding: 0.1,
		minimalWidth: 400,
	},
	minimalProductDiameter: 50,
};

export default settings;

export { margins };
